
















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { MountingPortal } from 'portal-vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { component as VueTouch } from 'vue-touch';
import scrollbarWidth from '@/utils/scrollbarWidth';

@Component({
    inheritAttrs: false,
    components: { MountingPortal, VueTouch },
})
export default class Modal extends Vue {
    /**
     *
     */
    @Prop({ default: false })
    public readonly active!: boolean;
    /**
     *
     */
    @Prop()
    public readonly swipeDownMaxDistance!: number;
    /**
     *
     */
    @Ref()
    public readonly modal!: InstanceType<typeof VueTouch>;
    /**
     *
     */
    @Ref()
    public readonly scroller!: HTMLElement;
    /**
     *
     */
    @Ref()
    public readonly inner!: HTMLElement;
    /**
     *
     */
    public onEscape(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.$emit('close');
        }
    }
    /**
     *
     */
    public onTransitionBeforeEnter(el: HTMLElement) {
        document.body.style.paddingRight = scrollbarWidth() + 'px';
        document.body.style.overflow = 'hidden';
        this.$emit('before-enter', el);
    }
    /**
     *
     */
    public onTransitionEnter(el: HTMLElement) {
        disableBodyScroll(this.scroller);
        window.addEventListener('keyup', this.onEscape);
        this.$emit('enter', el);
    }
    /**
     *
     */
    public onTransitionBeforeLeave(el: HTMLElement) {
        enableBodyScroll(this.scroller);
        window.removeEventListener('keyup', this.onEscape);
        this.$emit('before-leave', el);
    }
    /**
     *
     */
    public onTransitionAfterLeave(el: HTMLElement) {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
        this.$emit('after-leave', el);
    }
    /**
     *
     */
    public onPanstart(_event: WheelEvent) {
        if (window.innerWidth > 960) {
            return;
        }

        const el = this.modal.$el as HTMLElement;
        el.style.transition = '';
    }
    /**
     *
     */
    public onPanend(event: WheelEvent) {
        if (window.innerWidth > 960) {
            return;
        }

        const modal = this.modal.$el as HTMLElement;

        if (
            this.swipeDownMaxDistance
                ? event.deltaY > this.swipeDownMaxDistance
                : event.deltaY > modal.offsetHeight * 0.4 // 40% от высоты блока
        ) {
            this.$emit('close');
        } else {
            modal.style.transform = '';
            modal.style.transition = `transform 0.3s`;
        }
    }
    /**
     *
     */
    public onPanmove(event: WheelEvent) {
        if (window.innerWidth > 960) {
            return;
        }

        const modal = this.modal.$el as HTMLElement;
        const scroller = this.scroller;
        const inner = this.inner;

        if (
            event.target === scroller ||
            (event.target as HTMLElement).closest('.modal__scroller')
        ) {
            if (inner.offsetHeight > scroller.offsetHeight) {
                return;
            }
        }

        // todo add vendor prefixes
        if (event.deltaY < 0) {
            modal.style.transform = `translateY(0px)`;
        } else {
            modal.style.transform = `translateY(${event.deltaY}px)`;
        }
    }
}
